"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addLoginProps;
var _react = _interopRequireDefault(require("react"));
var _LoginContext = require("./LoginContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/**
 * @deprecated Use the `useLogin` hook instead.
 * This will require converting class components
 * that use this to function components.
 */
function addLoginProps(WrappedComponent) {
  const LoginConnector = props => {
    const loginProps = (0, _LoginContext.useLogin)();
    return /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({}, props, loginProps));
  };
  LoginConnector.displayName = `LoginConnector(${getDisplayName(WrappedComponent)})`;
  return LoginConnector;
}